import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-location",
  "use": "icon-location-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-location\"><path d=\"M511.871 0a394.752 394.752 0 00-325.12 619.008 125.952 125.952 0 007.168 11.264l288.256 379.904A39.424 39.424 0 00511.871 1024a40.96 40.96 0 0030.72-15.36l286.72-378.368a88.576 88.576 0 006.656-10.24A394.752 394.752 0 00511.871 0zm0 536.064a141.312 141.312 0 11141.312-141.312 141.312 141.312 0 01-141.312 141.312z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol